// extracted by mini-css-extract-plugin
export var productImage = "_z3-0";